/*
 * @author BSG <dev@bsgroup.eu>
 * @copyright Better Software Group S.A.
 * @version: 1.0
 */
import { GetServerSideProps } from "next";

import PageNotFound, {
  type PageNotFoundProps,
} from "components/PageNotFound/PageNotFound";

export const getServerSideProps: GetServerSideProps<PageNotFoundProps> = async (
  ctx
) => {
  const { getCommonServerSideProps } = await import(
    "helpers/getCommonServerSideProps"
  );

  const referer = ctx.req.headers?.referer || undefined;

  const { commonProps } = await getCommonServerSideProps(ctx);
  return {
    props: {
      ...commonProps,
      referer,
    },
  };
};

export default PageNotFound;
